export const providerProfileImg = (payload) => {
  return {
    type: "providerProfileImg",
    payload,
  };
};
